var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":"","id":"app"}},[_c('Header'),_c('OurName'),_c('Countdown'),_c('Navigation'),_c('div',{staticClass:"css-mf7073"}),_c('router-view'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }